import GameEvent from './componant/GameEvent';
import styled from 'styled-components';
import GameHeader from './componant/GameHeader';
import Footer from '../components/footer/Footer';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import GameService from '../../service/game/GameService';
const GameItem = () => {
  const { gameId } = useParams<{ gameId: string }>();
  const parsedGameId = Number(gameId);
  const [gameTitle, setGameTitle] = useState<string>('');
  useEffect(() => {
    const fetchGameListAndFindTitle = async () => {
      try {
        const res = await GameService.list(1, 100);
        const gameList = res.data?.list || [];

        const matched = gameList.find(
          (game: any) => String(game.game_id) === String(gameId),
        );

        if (matched) {
          setGameTitle(matched.title);
        } else {
          setGameTitle('게임 정보를 찾을 수 없습니다.');
        }
      } catch (error) {
        console.error('게임 리스트 가져오기 실패:', error);
        setGameTitle('게임 정보를 불러오는 데 실패했습니다.');
      }
    };

    if (gameId) fetchGameListAndFindTitle();
  }, [gameId]);

  return (
    <Container>
      <GameHeader />
      <Content>
        <Inner>
          <Title>{gameTitle}</Title>
          <Text>해당 밸런스 게임의 랭킹을 확인해보세요!</Text>
          <GameEvent gameId={parsedGameId} />
        </Inner>
      </Content>
      <Footer />
    </Container>
  );
};

export default GameItem;
const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Inner = styled.div`
  width: 100%;
  padding: 40px 20px;
`;
const Container = styled.div`
  max-width: 900px;
  min-height: 100vh;
  margin: 0 auto;
  box-shadow: 0 0 20px hsla(0, 0%, 51%, 0.15);
  position: relative;
`;
const Title = styled.div`
  color: #000;

  /* Re_SPOQA/head/bold_24 */
  font-family: 'Spoqa Han Sans Neo';
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 34.8px */
  letter-spacing: -0.4px;
  margin-bottom: 12px;
`;

const Text = styled.div`
  color: rgba(0, 12, 30, 0.8);

  /* Re_SPOQA/sub_h/med_18 */
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 26.1px */
  letter-spacing: -0.36px;
`;
